import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common Functions
import { resetPassword } from "../../common/helpers/auth";

class Password extends Component {
  state = { email: "" };

  handleSubmitPassword = () => {
    this.growl.clear();
    resetPassword(this.state.email)
      .then(() => {
        this.growl.show({
          severity: "success",
          summary: <br />,
          detail: "Success: Password reset email sent",
          life: 3000
        });
      })
      .catch(error => {
        this.growl.show({
          severity: "error",
          summary: <br />,
          detail: error.toString(),
          life: 3000
        });
      });
  };

  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.handleSubmitPassword();
    }
  };

  render() {
    const s = this.state;

    return (
      <div className="login-body" onKeyPress={this.handleKeyPress}>
        <div className="ui-g">
          <div className="card login-panel ui-fluid">
            <pr.Growl
              style={{ textAlign: "left" }}
              ref={el => (this.growl = el)}
            />
            <div className="ui-g">
              <div className="ui-g-12">
                <img
                  src="/assets/layout/images/capcon/logo.png"
                  alt=""
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="ui-g-12">
                <span
                  className="md-inputfield form-field"
                  style={{ marginTop: "0px" }}
                >
                  <pr.InputText
                    value={s.email || ""}
                    onChange={e =>
                      this.setState({
                        email: e.target.value
                      })
                    }
                  />
                  <label className="input-label">Email Address</label>
                </span>
              </div>
              <div className="ui-g-12">
                <pr.Button
                  icon="pi pi-user-plus"
                  label="Reset Password"
                  onClick={() => {
                    this.handleSubmitPassword();
                  }}
                />
                <a href="#/">Sign In?</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Password;



// WEBPACK FOOTER //
// ./src/components/Password/Password.js